import React, { memo } from 'react';
import { WrapListContainer } from '@redlink/components/atoms';
import { PageItem } from '@redlink/components/muscles';
import { AddNewPageButton } from '@redlink/components/molecules';

export const PageList = memo(({ data, onSelect, onAddPress, archive }) => {
  return (
    <WrapListContainer>
      {data.map((item) => {
        return (
          <PageItem {...{ item, archive }} onSelect={() => onSelect(item)} />
        );
      })}
      {!archive && <AddNewPageButton onPress={onAddPress} />}
    </WrapListContainer>
  );
});
